/**
 * Turn an axios error into something worth showing a user.
 *
 * The API answers in three different shapes:
 *   { message }                       — our own handlers
 *   { errors: { field: [msg, ...] } } — ASP.NET model validation
 *   { title }                         — ProblemDetails
 * and a request that never arrived has none of them.
 */
export const apiErrorMessage = (err, fallback) => {
  const data = err?.response?.data;

  if (data) {
    if (typeof data === 'string' && data.trim()) return data;
    if (data.message) return data.message;

    if (data.errors && typeof data.errors === 'object') {
      const messages = Object.values(data.errors).flat().filter(Boolean);
      if (messages.length > 0) return messages.join(' ');
    }

    if (data.title) return data.title;
  }

  // 413 has no body worth reading, and a failed multipart read surfaces as a
  // bare 400 — say something more useful than "Request failed".
  const status = err?.response?.status;
  if (status === 413) return 'الملف كبير جداً. / File is too large.';

  return fallback || err?.message || 'Unknown error';
};

export default apiErrorMessage;
